import React, { useEffect } from 'react'

import 'react-loading-skeleton/dist/skeleton.css'
import 'react-tooltip/dist/react-tooltip.css'

import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import AppRoutes from '@src/AppRoutes'
import { AuthProvider } from '@src/providers/AuthProvider'
import EmbedProvider from '@src/providers/EmbedProvider'
import TronModalProvider from '@src/providers/TronModalProvider'
import { Web3ModalProvider } from '@src/providers/Web3ModalProvider'
import { isFeatureEnabled } from '@src/utils/environment'

const ASCII_ART = `
███╗   ███╗ █████╗  ██████╗██╗  ██╗
████╗ ████║██╔══██╗██╔════╝██║  ██║
██╔████╔██║███████║██║     ███████║
██║╚██╔╝██║██╔══██║██║     ██╔══██║
██║ ╚═╝ ██║██║  ██║╚██████╗██║  ██║
╚═╝     ╚═╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝
                                    
███████╗██╗  ██╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
██╔════╝╚██╗██╔╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
█████╗   ╚███╔╝ ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗  
██╔══╝   ██╔██╗ ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝  
███████╗██╔╝ ██╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
╚══════╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝
`

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnMount: false, refetchOnWindowFocus: false },
    },
})

const theme = createTheme({
    palette: {
        mode: 'dark',
    },
})

const App: React.FC = () => {
    useEffect(() => {
        console.log(ASCII_ART)
        console.log('Welcome to Mach.Exchange! 🚀')

        console.log('🔍 process.env.REACT_APP_FEATURE_GATE_ENV:', process.env.REACT_APP_FEATURE_GATE_ENV)
        console.log('🔍 process.env.REACT_APP_ENV:', process.env.REACT_APP_ENV)
        console.log('🔍 process.env.REACT_APP_IS_TESTNET_DEPLOYMENT:', process.env.REACT_APP_IS_TESTNET_DEPLOYMENT)

        console.log('🔍 process.env.REACT_APP_FEATHER_API_URL:', process.env.REACT_APP_FEATHER_API_URL)

        console.log('🔍 ENABLE_TESTNETS enabled:', isFeatureEnabled('ENABLE_TESTNETS'))
        console.log('🔍 USE_TESTNETS_ONLY enabled:', isFeatureEnabled('USE_TESTNETS_ONLY'))
        console.log('🔍 TRANSACTION_CAP enabled:', isFeatureEnabled('TRANSACTION_CAP'))
        console.log('🔍 ABSTRACT_CONNECTOR enabled:', isFeatureEnabled('ABSTRACT_CONNECTOR'))
    }, [])

    return (
        <MuiThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <TronModalProvider>
                    <Web3ModalProvider>
                        <AuthProvider>
                            <EmbedProvider>
                                <AppRoutes />
                            </EmbedProvider>
                        </AuthProvider>
                    </Web3ModalProvider>
                </TronModalProvider>
            </QueryClientProvider>
        </MuiThemeProvider>
    )
}

export default App
